import CloseIcon from '@mui/icons-material/Close';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import { Button,DialogActions,DialogContent,DialogTitle,Stack,Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { NewFormContext } from "../../../context/NewFormContext";
import { ChecklistType } from "../../../types/checklist/types";

type props = {
  itemId: string,
  open: boolean;
  handleCloseModal: Function;
  nome: string;
  subitemId: number,
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DeletaSubitem({ open, handleCloseModal, nome, itemId, subitemId }: props) {
  const { setModelo } = useContext(NewFormContext);
  const { t } = useTranslation('translation');

  function handleRemoveSubitem() {
    setModelo((prev: ChecklistType) => ({
      ...prev,
      itens: prev.itens?.map((item) =>
        item.id === itemId
          ? {
            ...item,
            subitens: item.subitens.filter((sub) => sub.id !== subitemId)
          }
          : item
      )
    }));
  }

  return (
    <BootstrapDialog
      onClose={() => handleCloseModal()}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Deletar item
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => handleCloseModal()}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Stack direction='row' spacing={2} alignItems='center' justifyContent='flex-start' padding={2}>
          <ReportGmailerrorredIcon color="error" fontSize="large" />
          <Typography textAlign='left' fontWeight={600}>Você tem certeza que deseja excluir o subitem: "{nome}"?</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleRemoveSubitem}>
          {t('yes')}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
}
